import setErrorDataArray from "./setErrorDataArray";

const sagaSetErrorHelperFn = (error:any) => {
  const { data } = error?.response;

  return setErrorDataArray(data);
};

export default sagaSetErrorHelperFn;
